export type LiteState = 'zero' | 'CVPreview' | 'completeExperience' | 'basicCV' | 'skillBasedCV';
export const liteStateCount = 4;
export const experiencesToComplete = 3;

export const isBasicCV = (experiencesCount: number) => experiencesCount >= experiencesToComplete;
export const isCompleteExperience = (completeExperiencesCount: number) =>
  completeExperiencesCount >= 1;

export const nextLiteGoal = (currentLiteState: LiteState, liteStates: LiteState[]) => {
  switch (currentLiteState) {
    case 'skillBasedCV':
      return 'complete';
    case 'basicCV':
      if (liteStates.includes('completeExperience')) {
        return 'skill';
      }
      return 'experience';
    case 'completeExperience':
      if (liteStates.includes('basicCV')) {
        return 'skill';
      }
      return 'basic';
    case 'CVPreview':
      return 'basic';
    case 'zero':
    default:
      return 'preview';
  }
};
